// Maps FastAPI/Pydantic error payloads to participant-friendly messages (BM labels).
const FIELD_LABELS = {
  reg_type: "Registration type",
  full_name: "Full name",
  nric_passport: "NRIC/Passport",
  email: "Email",
  contact_number: "Contact number",
  gender: "Gender",
  age_category: "Age category",
  weight_class: "Weight class",
  height_cm: "Height",
  jersey_size: "Jersey size",
  club_gym: "Club/gym name",
  coach_name: "Manager/coach name",
  coach_phone: "Coach phone",
  fight_record: "Fight record",
  nationality: "Nationality",
  date_of_birth: "Date of birth",
  age: "Umur",
  guardian_name: "Parent/guardian name",
  photo_path: "Profile photo",
};

const friendlyMsg = (msg) => {
  if (msg === "field required" || msg === "Field required") return "required";
  if (msg.startsWith("Value error, ")) return msg.replace("Value error, ", "");
  if (msg.includes("not a valid email")) return "invalid email format";
  if (msg.includes("String should match pattern")) return "invalid format — please check again";
  if (msg.includes("String should have at least")) return "too short";
  if (msg.includes("String should have at most")) return "too long";
  if (msg.includes("valid date")) return "invalid date format";
  if (msg.includes("value is not a valid")) return "invalid value";
  return msg;
};

export const labelFor = (key) => FIELD_LABELS[key] || key;

export const formatApiError = (detail) => {
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail
      .map((d) => {
        const key = d?.loc?.[d.loc.length - 1];
        const label = FIELD_LABELS[key] || key || "Field";
        return `${label}: ${friendlyMsg(d?.msg || "tidak sah")}`;
      })
      .join(" · ");
  }
  return "Please check your details and try again";
};
